export default [
    {key: 'DOCS' , name: 'เอกสารทุกประเภท'},
    {key: 'DRYFOOD' , name: 'อาหารแห้ง'},
    {key: 'FRUIT' , name: 'ผัก/ผลไม้'},
    {key: 'GENERAL' , name: 'ของใช้ทั่วไป'},
    {key: 'ELECTRONIC' , name: 'อุปกรณ์ไฟฟ้า อิเล็กทรอนิกส์'},
    {key: 'CLOTHING' , name: 'เสื้อผ้า/เครื่องนุ่งห่ม'},
    {key: 'MEDIA' , name: 'สื่อบันเทิง'},
    {key: 'AUTO_PARTS' , name: 'อะไหล่ยนต์'},
    {key: 'SHOES_BAGS' , name: 'รองเท้า/กระเป๋า'},
    {key: 'SECOND_HAND' , name: 'สินค้ามือสอง'},
    {key: 'COSMETICS' , name: 'เครื่องสำอาง'},
    {key: 'FURNITURE' , name: 'เฟอร์นิเจอร์'},
    {key: 'TEMPERATURE_CONTROL_PRODUCT' , name: 'สินค้าควบคุมอุณหภูมิ'},
    {key: 'ANIMAL_PLANT' , name: 'สิ่งมีชีวิต/ต้นไม้'},
    {key: 'LIQUID' , name: 'ของเหลว'},
    {key: 'CHEMICAL' , name: 'สารเคมี/ชีวเคมี'},
    {key: 'FLAMMABLE_MATERIAL' , name: 'วัตถุไวไฟ'},
    {key: 'MUSICAL_INSTRUMENT' , name: 'เครื่องดนตรี'},
    {key: 'BULK_GOODS' , name: 'สินค้าเทกอง'},
    {key: 'OTHER' , name: 'อื่นๆ(โปรดระบุ)'},
    {key: 'NOT_SPECIFIED' , name: 'ไม่ระบุ'},
]